import React from 'react';
import { Folder, Pencil, Trash2 } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { formatUnitConversion } from './catalogUnits';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const getImageUrl = (url) => (url && !url.startsWith('http') ? `${BACKEND_URL}${url}` : url);

const CategoryList = ({ categories, onEdit, onDelete }) => (
  <Card>
    <CardContent className="p-6">
      {categories.length === 0 ? (
        <div className="text-center py-8 text-gray-500" data-testid="no-categories">
          No categories yet. Add your first category above.
        </div>
      ) : (
        <div className="space-y-3" data-testid="categories-list">
          {categories.map((cat) => {
            const cid = cat._id || cat.id;
            return (
              <div
                key={cid}
                className={`flex items-center justify-between p-4 border rounded-lg ${
                  cat.is_active ? 'bg-white' : 'bg-gray-50 opacity-60'
                }`}
                data-testid={`category-item-${cid}`}
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded bg-green-100 flex items-center justify-center overflow-hidden">
                    {cat.image ? (
                      <img src={getImageUrl(cat.image)} alt={cat.name} className="w-full h-full object-cover" />
                    ) : (
                      <Folder className="h-6 w-6 text-green-600" />
                    )}
                  </div>
                  <div>
                    <p className="font-semibold">{cat.name}</p>
                    <p className="text-sm text-gray-500">{cat.description || 'No description'}</p>
                    <p className="text-xs text-gray-400">Slug: {cat.slug}</p>
                    <p className="text-xs text-green-700" data-testid={`category-unit-${cid}`}>
                      Default: {formatUnitConversion(cat.default_unit_value, cat.default_unit)}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-2 py-1 rounded text-xs ${
                    cat.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
                  }`}>
                    {cat.is_active ? 'Active' : 'Hidden'}
                  </span>
                  <button
                    onClick={() => onEdit(cat)}
                    className="p-2 rounded bg-blue-100 text-blue-600 hover:bg-blue-200"
                    data-testid={`edit-category-${cid}`}
                  >
                    <Pencil className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => onDelete(cid, cat.name)}
                    className="p-2 rounded bg-red-100 text-red-600 hover:bg-red-200"
                    data-testid={`delete-category-${cid}`}
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </CardContent>
  </Card>
);

export default CategoryList;
